<template>
  <div class="down-page">
    <div class="down-page-content">
      <!-- 产品列表 -->
      <div v-loading="loading">
        <div class="prod-list-block" v-if="dataSource.length">
          <card-list :data="item" v-for="(item, index) of dataSource" :key="index"></card-list>

          <div class="list-card-empty" v-for="item of 20" :key="`key_${item}`"></div>
        </div>
        <el-empty description="暂无数据" v-else></el-empty>
      </div>
      <div class="list-pagination">
        <md-page :page="page" :total="count" :pageSize="pageSize" @pagecallback="handleCurrentChange"></md-page>
      </div>
    </div>
  </div>
</template>

<script>
import { UserService } from "@/service";
import CardList from "@/components/card-list.vue";

export default {
  components: {
    CardList,
  },
  data() {
    return {
      page: 1,
      pageSize: 50,
      count: 0,
      loading: false,
      dataSource: [],
    };
  },
  methods: {
    handleClick() {
      this.getDataSource();
    },
    async getDataSource(page = 1) {
      this.loading = true;
      if (page === 1) {
        this.page = 1;
      } else {
        this.dataSource = [];
      }
  
      const res = await UserService.downProdLogsForUser(page, this.pageSize);
      if (res) {
        let { TotalCount, List } = res;
        this.dataSource = List;
        this.count = TotalCount || 0;
      }
      this.loading = false;
    },
    // 分页搜素
    handleCurrentChange(_page) {
      this.page = _page.page;
      this.getDataSource(_page.page);
    },
  },
  mounted() {
    this.getDataSource();
  },
};
</script>
<style lang="less" scoped>
.down-page {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 50px;
}

.prod-list-block {
  display: flex;
  flex-wrap: wrap;
}

.list-pagination {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 6px;
  left: 0;
}
</style>